import React from 'react';
import Login from './Login';

/**
 * Administrative login page.  For now it simply renders the
 * normal login component; the component itself detects the
 * current pathname and adjusts its UI/behaviour accordingly.
 *
 * Having a dedicated file prevents broken imports and makes the
 * route explicit in App.js, which was the original concern.
 */
const AdminLogin = () => {
  return <Login />;
};

export default AdminLogin;
